import {ProductCategory} from "types";

import styles from './ProductPage.module.scss';

export type PageBreadcrumbsProps = {
  category: ProductCategory
}

export const PageBreadcrumbs = ({}: PageBreadcrumbsProps) => {

  return (
    <div className={styles.breadcrumbs}>
      {/*PageBreadcrumbs*/}
    </div>
  );
};
